import { IconAlertSquareRoundedFilled } from "@tabler/icons-react";
import { useEffect, useState } from "react";

function useIsMobileOrTabletPortrait() {
	const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

	useEffect(() => {
		function checkScreen() {
			const width = window.innerWidth;
			const height = window.innerHeight;
			const isMobile = width <= 767;
			const isTabletPortrait = width > 767 && width <= 1024 && height > width;

			setIsMobileOrTablet(isMobile || isTabletPortrait);
		}

		checkScreen();
		window.addEventListener("resize", checkScreen);
		return () => window.removeEventListener("resize", checkScreen);
	}, []);

	return isMobileOrTablet;
}

export default function MobileSupportWarning() {
	const showWarning = useIsMobileOrTabletPortrait();

	if (!showWarning) return null;

	return (
		<div className="!z-[9999] fixed inset-0 flex justify-center items-center w-screen h-screen bg-background">
			<div className="flex flex-col justify-center items-center w-full max-w-[380px] p-4 gap-4">
				<div className="inline-flex justify-center items-center w-[70px] h-[70px] rounded-full bg-primary-100 text-primary-600">
					<IconAlertSquareRoundedFilled size={32} />
				</div>
				<div className="flex flex-col w-full gap-1">
					<span className="text-center text-lg font-semibold text-foreground-dark">Oh No!</span>
					<span className="text-center text-base text-foreground-dark">
						This web app does not currently support mobile devices or smaller screens. Please use desktop or laptop for better user experience.
					</span>
				</div>
			</div>
		</div>
	);
}
